import { lazy, Suspense, type ReactNode } from 'react';
import { createBrowserRouter } from 'react-router';
import { AppShell } from '@/shell/AppShell';
import { HomePage } from '@/pages/home/HomePage';
import { RouteError } from './RouteError';

const ExplorePage = lazy(() => import('@/pages/explore/ExplorePage'));
const CoinPage = lazy(() => import('@/pages/coin/CoinPage'));
const CreatePage = lazy(() => import('@/pages/create/CreatePage'));
const ProfilePage = lazy(() => import('@/pages/profile/ProfilePage'));
const LeaderboardPage = lazy(() => import('@/pages/leaderboard/LeaderboardPage'));
const SoonPage = lazy(() => import('@/pages/soon/SoonPage'));
const NotFoundPage = lazy(() => import('@/pages/NotFoundPage'));

const page = (el: ReactNode) => <Suspense fallback={<div className="p-6"><div className="skeleton h-6 w-48" /></div>}>{el}</Suspense>;

export const router = createBrowserRouter([
  {
    element: <AppShell />,
    errorElement: <RouteError />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'explore', element: page(<ExplorePage />) },
      { path: 'coin/:mint', element: page(<CoinPage />) },
      { path: 'create', element: page(<CreatePage />) },
      { path: 'profile/:wallet', element: page(<ProfilePage />) },
      { path: 'leaderboard', element: page(<LeaderboardPage />) },
      { path: 'live', element: page(<SoonPage feature="live" />) },
      { path: 'bounties', element: page(<SoonPage feature="bounties" />) },
      { path: 'holder-rewards', element: page(<SoonPage feature="holder-rewards" />) },
      { path: '*', element: page(<NotFoundPage />) },
    ],
  },
]);
